import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button, FormLabel } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { io } from "socket.io-client";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const GridBot = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const path = usercalls();
  const [createGridBot, setCreateGridBot] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [count, setCount] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    pairs: "",
    upperPrice: "",
    lowerPrice: "",
    quantity: "",
    grids_quantity: "",
    gridType: "",
    currencytype: "",
    profitcurrency: "",
    uppersl: "",
    lowersl: "",
    leverage: "",
    Trailingup: "disable",
    Trailingdown: "disable",
    Expansionup: "",
    Expansiondown: "",
  });

  const [savedBots, setSavedBots] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pairs, setPairs] = useState([]);
  const [pairSearch, setPairSearch] = useState("");
  const [pairsLoading, setPairsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [currencyRates, setCurrencyRates] = useState({});
  const getPairLabel = (pairItem) =>
    typeof pairItem === "string"
      ? pairItem
      : pairItem?.pair || pairItem?.symbol || pairItem?.name || pairItem?.label;
  const getPairValue = (pairItem) =>
    typeof pairItem === "string"
      ? pairItem
      : pairItem?.pair || pairItem?.symbol || pairItem?.name || pairItem?.value;
  const normalizedPairSearch = pairSearch.trim().toLowerCase();
  const filteredPairs = pairs.filter((pairItem) => {
    if (!normalizedPairSearch) return true;
    const label = String(getPairLabel(pairItem) || "").toLowerCase();
    const value = String(getPairValue(pairItem) || "").toLowerCase();
    return (
      label.includes(normalizedPairSearch) ||
      value.includes(normalizedPairSearch)
    );
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pairs") {
      const pair = String(value || "")
        .split(",")[0]
        .trim();
      if (pair) {
        getCurrencyRates(pair);
      } else {
        setCurrencyRates({});
      }
      setPairSearch("");
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getCurrencyRates = async (pair) => {
    try {
      const url = `https://api.3commas.io/public/api/ver1/accounts/currency_rates?market_code=kucoin&pair=${pair}`;
      const { data } = await axios.get(url);
      if (data) {
        setCurrencyRates(data);
      } else {
        setCurrencyRates({});
      }
    } catch (err) {
      setCurrencyRates({});
    }
  };

  const getPairs = async () => {
    try {
      setPairsLoading(true);
      const url = `${consts.BackendUrl}/bots/get-trading-pairs`;
      const payload = {};
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success || Array.isArray(result)) {
        setPairs(Array.isArray(result) ? result : result?.result || []);
      } else {
        setPairs([]);
      }
      setPairsLoading(false);
    } catch (err) {
      setPairs([]);
      setPairsLoading(false);
    }
  };

  const isNumeric = (value) => {
    return value !== "" && !isNaN(value) && !isNaN(parseFloat(value));
  };

  const validateForm = (data) => {
    if (!data.name || data.name.trim().length === 0)
      return "Bot name is required";
    if (!data.pairs || data.pairs.trim().length === 0)
      return "Trading pair is required";
    if (!data.upperPrice) return "Upper price is required";
    if (!isNumeric(data.upperPrice))
      return "Upper price must be a valid number";
    if (parseFloat(data.upperPrice) <= 0)
      return "Upper price must be greater than 0";
    if (!data.lowerPrice) return "Lower price is required";
    if (!isNumeric(data.lowerPrice))
      return "Lower price must be a valid number";
    if (parseFloat(data.lowerPrice) <= 0)
      return "Lower price must be greater than 0";
    if (parseFloat(data.lowerPrice) >= parseFloat(data.upperPrice))
      return "Lower price must be less than upper price";

    const upperPrice = Number(data.upperPrice);
    const lowerPrice = Number(data.lowerPrice);
    const currentPrice = Number(currencyRates?.last);
    const hasCurrentPrice = Number.isFinite(currentPrice) && currentPrice > 0;

    // Current market price should not be above the configured upper grid limit.
    if (hasCurrentPrice && currentPrice >= upperPrice)
      return "Upper price must be greater than current price";
    if (!data.quantity) return "Grid quantity is required";
    if (!isNumeric(data.quantity))
      return "Grid quantity must be a valid number";
    if (parseFloat(data.quantity) <= 0)
      return "Grid quantity must be greater than 0";
    if (!data.grids_quantity) return "Number of grids is required";
    if (!isNumeric(data.grids_quantity))
      return "Number of grids must be a valid number";
    if (!Number.isInteger(Number(data.grids_quantity)))
      return "Number of grids must be a whole number";
    if (parseInt(data.grids_quantity, 10) <= 0)
      return "Number of grids must be greater than 0";
    if (!data.gridType) return "Grid type is required";
    if (
      !["Geometric", "Arithmetic", "geometric", "arithmetic"].includes(
        data.gridType,
      )
    )
      return "Grid type must be Geometric or Arthmetic";

    // Optional fields validation
    if (
      data.profitcurrency &&
      !["base_currency", "quote_currency"].includes(data.profitcurrency)
    )
      return "Profit currency must be base_currency or quote_currency";
    if (data.uppersl) {
      if (!isNumeric(data.uppersl))
        return "Upper stop loss must be a valid number";
      if (parseFloat(data.uppersl) <= 0)
        return "Upper stop loss must be greater than 0";

      if (Number(data.uppersl) <= upperPrice)
        return "Upper stop loss must be greater than upper price";
    }
    if (data.lowersl) {
      if (!isNumeric(data.lowersl))
        return "Lower stop loss must be a valid number";
      if (parseFloat(data.lowersl) <= 0)
        return "Lower stop loss must be greater than 0";

      if (Number(data.lowersl) >= lowerPrice)
        return "Lower stop loss must be less than lower price";
    }

    if (data.uppersl && data.lowersl) {
      if (Number(data.lowersl) >= Number(data.uppersl))
        return "Lower stop loss must be less than upper stop loss";
    }
    if (
      data.leverage &&
      !["Cross", "Isolated", "cross", "isolated", "not_specified"].includes(
        data.leverage,
      )
    )
      return "Leverage must be Cross, Isolated, or Not Specified";
    if (data.Trailingup && !["enable", "disable"].includes(data.Trailingup))
      return "Trailing up must be enable or disable";
    if (data.Trailingdown && !["enable", "disable"].includes(data.Trailingdown))
      return "Trailing down must be enable or disable";
    if (data.Expansionup && !isNumeric(data.Expansionup))
      return "Expansion up price must be a valid number";
    if (data.Expansiondown && !isNumeric(data.Expansiondown))
      return "Expansion down price must be a valid number";

    return null;
  };

  const handleSubmit = async () => {
    const err = validateForm(formData);
    if (err) {
      toast.error(err);
      return;
    }

    setSubmitLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/create-grid-bot`;
      // const payload = {
      //   id: editIndex !== null ? savedBots[editIndex]?.id : undefined,
      //   currentPrice: currencyRates.last,
      //   name: formData.name,
      //   pair: formData.pairs,
      //   upper_price: formData.upperPrice,
      //   lower_price: formData.lowerPrice,
      //   grids_quantity: parseInt(formData.grids_quantity, 10),
      //   quantity_per_grid: parseFloat(formData.quantity),
      //   grid_type: formData.gridType?.toLowerCase(),
      //   order_currency_type: formData.currencytype?.replace("_currency", ""),
      //   profit_currency_type: formData.profitcurrency
      //     ? formData.profitcurrency.replace("_currency", "")
      //     : undefined,
      //   upper_stop_loss_enabled: !!formData.uppersl,
      //   upper_stop_loss_price: formData.uppersl || undefined,
      //   lower_stop_loss_enabled: !!formData.lowersl,
      //   lower_stop_loss_price: formData.lowersl || undefined,
      //   leverage_type: formData.leverage
      //     ? formData.leverage.toLowerCase()
      //     : undefined,
      //   trailing_up_enabled: !!formData.Trailingup,
      //   trailing_down_enabled: !!formData.Trailingdown,
      //   expansion_up_enabled: !!formData.Expansionup,
      //   expansion_down_enabled: !!formData.Expansiondown,
      //   expansion_up_stop_price: formData.Expansionup || undefined,
      //   expansion_down_stop_price: formData.Expansiondown || undefined,
      // };
      const payload = {
        id: editIndex !== null ? savedBots[editIndex]?.id : undefined,
        currentPrice: currencyRates.last,
        name: formData.name,
        pair: formData.pairs,
        upper_price: parseFloat(formData.upperPrice),
        lower_price: parseFloat(formData.lowerPrice),
        grids_quantity: parseInt(formData.grids_quantity, 10),
        quantity_per_grid: parseFloat(formData.quantity),
        grid_type: formData.gridType?.toLowerCase(),
        order_currency_type: formData.currencytype?.replace("_currency", ""),
        profit_currency_type: formData.profitcurrency
          ? formData.profitcurrency.replace("_currency", "")
          : undefined,
        upper_stop_loss_enabled: !!formData.uppersl,
        upper_stop_loss_price: formData.uppersl || undefined,
        lower_stop_loss_enabled: !!formData.lowersl,
        lower_stop_loss_price: formData.lowersl || undefined,
        leverage_type: formData.leverage
          ? formData.leverage.toLowerCase()
          : undefined,
        trailing_up_enabled: formData.Trailingup === "enable",
        trailing_down_enabled: formData.Trailingdown === "enable",
        expansion_up_enabled: !!formData.Expansionup,
        expansion_down_enabled: !!formData.Expansiondown,
        expansion_up_stop_price: formData.Expansionup || undefined,
        expansion_down_stop_price: formData.Expansiondown || undefined,
      };

      if (!payload.id) delete payload.id;

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(
          `Grid Bot ${editIndex !== null ? "updated" : "created"} successfully`,
        );
        setCreateGridBot(false);
        setEditIndex(null);
        getGridBots();
        setFormData({
          name: "",
          pairs: "",
          upperPrice: "",
          lowerPrice: "",
          quantity: "",
          grids_quantity: "",
          gridType: "",
          currencytype: "",
          profitcurrency: "",
          uppersl: "",
          lowersl: "",
          leverage: "",
          Trailingup: "disable",
          Trailingdown: "disable",
          Expansionup: "",
          Expansiondown: "",
        });
      } else {
        toast.error(result?.message || "Failed to save Grid Bot");
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred while saving Grid Bot");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleEdit = (item, index) => {
    setFormData({
      name: item.name || "",
      pairs: item.pair || "",
      upperPrice: item.upper_price || "",
      lowerPrice: item.lower_price || "",
      quantity: item.quantity_per_grid || "",
      grids_quantity: item.grids_quantity || "",
      gridType: item.grid_type || "",
      uppersl: item.upper_stop_loss_price || "",
      lowersl: item.lower_stop_loss_price || "",
      leverage: item.leverage_type ? item.leverage_type.toLowerCase() : "",
      Trailingup: item.trailing_up_enabled ? "enable" : "disable",
      Trailingdown: item.trailing_down_enabled ? "enable" : "disable",
      Expansionup: item.expansion_up_stop_price || "",
      Expansiondown: item.expansion_down_stop_price || "",
    });
    setEditIndex(index);
    setCreateGridBot(true);
  };

  const handleDelete = async (botId) => {
    setDeleteLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/delete-grid-bot`;
      const payload = { id: botId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Grid Bot deleted successfully");
        getGridBots();
      } else {
        toast.error(result?.message || "Failed to delete Grid Bot");
      }
    } catch (err) {
      toast.error("Failed to delete Grid Bot");
    } finally {
      setDeleteLoading(false);
    }
  };

  const getGridBots = async () => {
    try {
      const url = `${consts.BackendUrl}/bots/get-grid-botlist?page=${page + 1}&limit=${rowsPerPage}`;
      const payload = {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        const pageResult = result?.result || {};
        const docs = Array.isArray(pageResult?.docs) ? pageResult.docs : [];
        const totalDocs = Number(pageResult?.totalDocs) || 0;
        const backendPage = Math.max(Number(pageResult?.page || 1) - 1, 0);

        setSavedBots(docs);
        setCount(totalDocs);

        if (backendPage !== page) {
          setPage(backendPage);
        }
      } else {
        setSavedBots([]);
        setCount(0);
      }
    } catch (error) {
      setCount(0);
      setSavedBots([]);
    }
  };
  useEffect(() => {
    const socket = io(consts?.socketUrl, {
      path: "/socket",
    });
    socket.on("connect", () => {
      socket.emit("join", {
        room: localStorage.getItem("use"),
      });
      console.log("socket connected");
    });

    socket.on("gridBotDeleted", (data) => {
      try {
        getGridBots();
      } catch (e) {
        console.log(e);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    getGridBots();
  }, [page, rowsPerPage]);

  useEffect(() => {
    getPairs();
  }, []);

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      {count === 0 ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "60vh" }}
        >
          <Grid item xs={11} sm={8} md={6} lg={4}>
            <div
              style={{
                border: "1px solid #2a2a2a",
                borderRadius: "12px",
                padding: "40px",
                textAlign: "center",
                background: "#0f0f0f",
              }}
            >
              <h2 style={{ marginBottom: "30px" }}>Grid Bot</h2>

              <Button
                variant="contained"
                onClick={() => setCreateGridBot(true)}
                style={{
                  padding: "10px 30px",
                  borderRadius: "8px",
                }}
              >
                Create Grid Bot{" "}
              </Button>
            </div>
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid container className="mb-20">
            <Grid item xs={12}>
              <div className="support-head bot_dash display-2 mb-20 p-2 flex-wrap">
                <div className="bot-heading"> Grid Bot</div>

                <div className="bot_comman_btn">
                  <Button onClick={() => setCreateGridBot(true)}>
                    Create Grid Bot
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} className="mt-20">
            {savedBots.map((item, index) => (
              <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                <div className="bot_container contain-width">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <div className="display-2">
                        <h3>Profile</h3>
                        <div className="bot_comman_btn green-btn">
                          <Button
                            onClick={() =>
                              navigate("/gridorderlist", { state: item })
                            }
                          >
                            View Bot
                          </Button>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Name</h4>
                        <div>{item.name || "----"}</div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Pairs</h4>
                        <div>{item.pair || "----"}</div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Grid Quantity</h4>
                        <div>{item.grids_quantity || "----"}</div>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Currency Type</h4>
                        <div>
                          {item.order_currency_type === "base"
                            ? "Base"
                            : item.order_currency_type === "quote"
                              ? "Quote"
                              : item.order_currency_type || "Quote"}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Profit Currency</h4>
                        <div>
                          {item.profit_currency_type === "base"
                            ? "Base"
                            : item.profit_currency_type === "quote"
                              ? "Quote"
                              : item.profit_currency_type || "Quote"}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div className="display-2">
                        <div className="bot_comman_btn">
                          <Button onClick={() => handleEdit(item, index)}>
                            Edit
                          </Button>
                        </div>

                        <div className="bot_comman_btn red-btn">
                          <Button
                            onClick={() => {
                              setDeleteIndex(item.id);
                              setOpenConfirm(true);
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            ))}
          </Grid>

          <div
            className="display-2 mt-20"
            style={{ justifyContent: "flex-end" }}
          >
            <TablePagination
              component="div"
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10]}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
            />
          </div>
        </>
      )}
      <Modal
        open={createGridBot}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">
              {editIndex !== null ? "Edit Grid Bot" : "Create Grid Bot"}
            </div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={() => {
                setCreateGridBot(false);
                setEditIndex(null);
              }}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            className=""
            style={{ maxHeight: "400px", overflow: "auto" }}
          >
            <FormLabel
              size="small"
              sx={{ color: "var(--clr-font)", fontSize: "12px", mt: 0 }}
            >
              Current Price : {currencyRates?.last ? currencyRates.last : 0}{" "}
              USDT
            </FormLabel>
            <TextField
              label="Name (required)"
              name="name"
              fullWidth
              className="bot-input"
              value={formData.name}
              onChange={handleChange}
              required
            />

            {editIndex !== null ? (
              <TextField
                label="Pairs (required)"
                name="pairs"
                fullWidth
                className="bot-input"
                value={formData.pairs}
                required
                InputProps={{ readOnly: true }}
              />
            ) : pairs && pairs.length > 0 ? (
              <FormControl fullWidth required>
                <InputLabel id="pair-label">Pairs (required)</InputLabel>
                <Select
                  className="bot-select"
                  fullWidth
                  name="pairs"
                  value={formData.pairs}
                  onChange={handleChange}
                  labelId="pair-label"
                  label="Pairs (required)"
                  required
                  disabled={pairsLoading}
                >
                  <MenuItem value="">Select Pair</MenuItem>
                  <TextField
                    size="small"
                    placeholder="Search pairs"
                    className="bot-input"
                    fullWidth
                    value={pairSearch}
                    onChange={(e) => setPairSearch(e.target.value)}
                    onKeyDown={(e) => e.stopPropagation()}
                    sx={{ width: "90%", margin: "10px auto", display: "block" }}
                  />
                  {filteredPairs.map((p, idx) => {
                    const label = getPairLabel(p);
                    const value = getPairValue(p);
                    return (
                      <MenuItem key={idx} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                  {filteredPairs.length === 0 && (
                    <MenuItem disabled>No pairs found</MenuItem>
                  )}
                </Select>
              </FormControl>
            ) : (
              <TextField
                label="Pairs"
                name="pairs"
                fullWidth
                className="bot-input"
                value={formData.pairs}
                onChange={handleChange}
                required
              />
            )}

            <TextField
              label="Upper Price (required)"
              name="upperPrice"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.upperPrice}
              onChange={handleChange}
              required
            />
            <TextField
              label="Lower Price (required)"
              name="lowerPrice"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.lowerPrice}
              onChange={handleChange}
              required
            />

            <TextField
              label="Quantity per Grid (required)"
              name="quantity"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.quantity}
              onChange={handleChange}
              required
            />
            <TextField
              label="Grid Quantity (required)"
              name="grids_quantity"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.grids_quantity}
              onChange={handleChange}
              required
            />
            <FormControl fullWidth required>
              <InputLabel id="grid-type-label">Grid Type (required)</InputLabel>
              <Select
                className="bot-select"
                name="gridType"
                value={formData.gridType || ""}
                onChange={handleChange}
                labelId="grid-type-label"
                label="Grid Type (required)"
                required
              >
                <MenuItem value="" disabled>
                  Select Grid Type
                </MenuItem>

                <MenuItem value="geometric">Geometric</MenuItem>
                <MenuItem value="arithmetic">Arithmetic</MenuItem>
              </Select>
            </FormControl>

            {/* <FormControl fullWidth>
              <InputLabel id="profit-currency-label">
                Profit Currency (optional)
              </InputLabel>
              <Select
                className="bot-select"
                name="profitcurrency"
                value={formData.profitcurrency || ""}
                onChange={handleChange}
                labelId="profit-currency-label"
                label="Profit Currency (optional)"
              >
                <MenuItem value="" disabled>
                  Select Profit Currency
                </MenuItem>

                <MenuItem value="base_currency">Base Currency</MenuItem>
                <MenuItem value="quote_currency">Quote Currency</MenuItem>
              </Select>
            </FormControl> */}

            <TextField
              label="Upper Stop Loss"
              name="uppersl"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.uppersl}
              onChange={handleChange}
            />
            <TextField
              label="Lower Stop Loss"
              name="lowersl"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.lowersl}
              onChange={handleChange}
            />

            {/* <FormControl fullWidth>
              <InputLabel id="leverage-label">Leverage (optional)</InputLabel>
              <Select
                className="bot-select"
                fullWidth
                name="leverage"
                value={formData.leverage || ""}
                onChange={handleChange}
                labelId="leverage-label"
                label="Leverage (optional)"
              >
                <MenuItem value="" disabled>
                  Select Leverage
                </MenuItem>
                <MenuItem value="cross">Cross</MenuItem>
                <MenuItem value="isolated">Isolated</MenuItem>
              </Select>
            </FormControl> */}

            <FormControl fullWidth>
              <InputLabel id="trailing-up-label">Trailing Up</InputLabel>
              <Select
                className="bot-select"
                name="Trailingup"
                value={formData.Trailingup || "disable"}
                onChange={handleChange}
                labelId="trailing-up-label"
                label="Trailing Up"
              >
                <MenuItem value="enable">Enable</MenuItem>
                <MenuItem value="disable">Disable</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="trailing-down-label">Trailing Down</InputLabel>
              <Select
                className="bot-select"
                name="Trailingdown"
                value={formData.Trailingdown || "disable"}
                onChange={handleChange}
                labelId="trailing-down-label"
                label="Trailing Down"
              >
                <MenuItem value="enable">Enable</MenuItem>
                <MenuItem value="disable">Disable</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Expansion Up Price"
              name="Expansionup"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.Expansionup}
              onChange={handleChange}
            />

            <TextField
              label="Expansion Down Price"
              name="Expansiondown"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.Expansiondown}
              onChange={handleChange}
            />
          </Box>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <Box sx={style}>
          <div className="p-20">Are you sure want to delete this bot?</div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => {
                  setOpenConfirm(false);
                  setDeleteIndex(null);
                }}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  handleDelete(deleteIndex);
                  setOpenConfirm(false);
                  setDeleteIndex(null);
                }}
                disabled={deleteLoading}
              >
                {deleteLoading ? "Deleting..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default GridBot;
